import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, Icon } from './elements';
import ChaMeta04 from 'dc/ChaMeta04';

function ChaMeta07(props) {
  return (
    <Wrapper className={props.className}>
      <Icon icon="icon-team" yourTeam={props.yourTeam} />
      <ChaMeta04 title={props.title} icon="icon-people">
        {props.children}
      </ChaMeta04>
    </Wrapper>
  );
}

ChaMeta07.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  yourTeam: PropTypes.any,
  children: PropTypes.node,
};

export default ChaMeta07;
